import React, { useRef } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Popper from '@mui/material/Popper';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { ClickAwayListener } from '@mui/material';
import colors from '../../../../../../scss/colors';
import { useWindowSize } from '../../../../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../../../../utils/constants';
import MainButton from '../../../../buttons/MainButton';
import BaseSwipeableDrawer from '../../../../BaseSwipeableDrawer/BaseSwipeableDrawer';
import classes from './BasicFilterDropdown.module.scss';

export default function BasicFilterDropdown({ type, text, mobileWithHeader = true, active, open, setOpen, children }) {
  const size = useWindowSize();
  const ref = useRef(null);
  const { t } = useTranslation();

  return (
    <>
      <div
        ref={ref}
        role="presentation"
        className={`${classes.mainInput} ${active ? classes.active : ''} ${open ? classes.openState : ''}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        {text}
        <KeyboardArrowDownIcon sx={{ color: active ? '#F5F7FA' : colors.DARKEST_GREY, margin: '-24px 0' }} />
      </div>
      {open && size.width <= responsiveSizeTimesheet && (
        <BaseSwipeableDrawer closeHandler={() => setOpen(false)}>
          <div className={classes.swiper} />
          {mobileWithHeader && (
            <>
              <p className={classes.typeOfFilter}>{type}</p>
              <div className={classes.divider} />
            </>
          )}
          {children}
          <MainButton size="small" variant="primary" rounded forceWidth="90%" action={() => setOpen(false)}>
            {t('common.general.showresults')}
          </MainButton>
        </BaseSwipeableDrawer>
      )}
      {open && size.width > responsiveSizeTimesheet && (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <Popper open anchorEl={ref.current}>
            <Box
              sx={{
                padding: '30px 0',
                backgroundColor: colors.PAGE_BACKGROUND,
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                borderRadius: '20px'
              }}
            >
              {children}
            </Box>
          </Popper>
        </ClickAwayListener>
      )}
    </>
  );
}
